// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"fa3fa210","491":"3c078e37","506":"2c81c350","549":"78925560","610":"52b80868","668":"38eb8d4a","763":"57c80b4c"}[chunkId] + ".chunk.css";
};